import { render, staticRenderFns } from "./ClassesList.vue?vue&type=template&id=32eb1edc&scoped=true"
import script from "./ClassesList.vue?vue&type=script&lang=js"
export * from "./ClassesList.vue?vue&type=script&lang=js"
import style0 from "./ClassesList.vue?vue&type=style&index=0&id=32eb1edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb1edc",
  null
  
)

export default component.exports